<div class="new-order-container">
<!-- header Section -->
<header *ngIf="!isEmbedded"
  class="header new-analysis-header Spacebox__l-large profile-header Flexbox Flexbox__box-direction-column Flexbox__just-center">
  <div class="Flexbox" *ngIf="tempWorkflowRequest && tempWorkflowRequest.orderBranding">
    <div class="bold">
      {{tempWorkflowRequest.orderBranding.label}}
    </div>
  </div>
  <div class="Flexbox" *ngIf="patientVal?.id">
    <div class="bold Spacebox__lr-small" id="patientName">
      {{patientVal.name[0].given[0]}} {{patientVal.name[0].family[0]}}
    </div>
    <gen-user-counter-warning [backUrl]="'dashboard.pathologist.order'" class="multiple-patients-warning"
      [userId]="patientVal?.id" [showDuplicatePatient]="checkIfDuplicate()" [name]="patientVal.name[0].text"
      [params]="{name: patientVal.name[0].text, userId: patientVal?.id, from: 'new-order'}">
    </gen-user-counter-warning>
    <div class="Spacebox__lr-small" *ngIf="patientVal.identifier[0].type.coding[0].code == 'MRN'">
      <span class="Spacebox__r-small fntSizeSmall">{{'MRN' | translate}}</span>
      <span class="bold" id="mrnNumber">{{patientVal.identifier[0].value}}</span>
    </div>
    <div class="Spacebox__lr-small">
      <span class="Spacebox__r-small fntSizeSmall">{{genderText | translate}}</span>
      <span class="bold" id="gender">{{patientVal.gender}}</span>
    </div>
    <div class="Spacebox__lr-small">
      <span class="Spacebox__r-small fntSizeSmall">{{'DOB' | translate}}</span>
      <span class="bold" id="birthDate">{{patientVal.birthDate}}</span>
    </div>
  </div>
</header>

<!-- Form Section -->
<form name="form" class="order-form form-horizontal" (ngSubmit)="submit()" novalidate autocomplete="off">
  <div class="order-form-container">
    <div class="Flexbox  analysis-title" [ngClass]="{'fit-on-full-screen':fitElementsInFullScreen}">
      <span>{{title | translate}}</span>
    </div>
    <div class="Flexbox">
      <div class="order-form-content" [ngClass]="{'fit-on-full-screen':fitElementsInFullScreen}">
        <div
          [ngClass]="{'Flexbox Flexbox-direction-rows order-form-content half-width':showPatientAndInstitute(),'half-max-width':!showPatientAndInstitute() || !showTestNumberAndType()}">

          <div class="Flexbox__flex-1" *ngIf="showPatientAndInstitute()">

            <!-- Institute data -->
            <div class="order-form-item Flexbox required" [ngClass]="{'required':dynamicInstitute && showSearch }">
              <div class="order-form-item  Flexbox">
                <label class="control-label order-form-title "
                  [ngClass]="{'required-text-color':dynamicInstitute && showSearch && isSubmitted}">
                  {{'Institute:' | translate}} <span class="fntRed">*</span> </label>
                <label class="control-label order-form-value order-form-value" *ngIf="!dynamicInstitute || showSearch"
                  translate>
                  <ng-container *ngIf="isAdmin();else notAdminUser">
                    <span id="instituteName">{{currentOrgName}}</span><span class="fntRed">*</span>
                  </ng-container>
                  <ng-template  #notAdminUser>
                    <span id="instituteName">{{diagnosticOrder.managingOrganization}}</span><span
                    class="fntRed">*</span>
                  </ng-template>
                </label>
              </div>
              <div *ngIf="dynamicInstitute && !showSearch" class="order-form-value">
                <select [(ngModel)]="orgName" class="form-control" required name="orderOnBehalf" (change)="orgChange(orgName)">
                  <option *ngFor="let org of availableOrganizations" [ngValue]="org.name"
                    [selected]="orgName == org.name">{{org.name}}</option>
                </select>
              </div>
            </div>

            <!-- patientVal doesn't exist, select or create -->
            <div *ngIf="!patientCheck || showPatient()" class="order-form-item  Flexbox"
              [ngClass]="{'required':!patientVal?.id}">
              <div class="order-form-title patient-title order-form-title-bottom">
                <label class="control-label mrgAuto">{{'Patient:' | translate}} </label>
                <button type="button" class="btn btn-primary" (click)="createPatient()">{{'Create new patient' |
                  translate}}</button>
                <span class="pad10">{{'or' | translate}}</span>
              </div>
              <div class="order-form-value new-order-patient-search-holder">
                <p-autoComplete inputId="new-order-patient-search" inputStyleClass="new-order-patient-search" placeholder="Search patient" field="patientVal"
                                [ngModel]="patientVal"
                                [ngModelOptions]="{standalone: true}"
                                [minLength]="2"
                                [suggestions]="filteredPatients"
                                [dropdown]="false"
                                (onSelect)="selectPatient($event)"
                                (completeMethod)="search($event)">
                  <ng-template let-value pTemplate="item">
                    <div class="Flexbox">
                      <span class="Flexbox__flex-1 fullName">
                        <P>{{value.name[0].given[0]}} </P>
                        <P>{{value.name[0].family[0]}}</P>
                      </span>
                      <span class="Flexbox__flex-1 Marginbox__l-small dateOfBirth">
                        <b class="Spacebox__r-tiny">DOB</b>
                        <p>{{value.birthDate}}</p>
                      </span>
                      <span class="Flexbox__flex-1 Marginbox__l-small mrn">
                        <b class="Spacebox__r-tiny">MRN</b>
                        <p *ngIf="value.identifier[0].type.coding[0].code == 'MRN'">{{value.identifier[0].value}}</p>
                      </span>
                    </div>
                  </ng-template>
                </p-autoComplete>
              </div>
            </div>

            <!-- patientVal exists, only show data -->
            <div *ngIf="patientVal?.id">
              <div class="order-form-item Flexbox">
                <label class="control-label order-form-title">{{'Patient Name:' | translate}} </label>
                <label class="control-label order-form-value" id="patientName">{{patientVal.name[0].given[0]}}
                  {{patientVal.name[0].family[0]}} </label>
              </div>
              <div class="order-form-item Flexbox" *ngIf="patientVal.identifier[0].type.coding[0].code == 'MRN'">
                <label class="control-label order-form-title">{{'MRN:' | translate}} </label>
                <label class="control-label order-form-value" id="mrnNumber">{{patientVal.identifier[0].value}} </label>
              </div>
              <div class="order-form-item Flexbox">
                <label class="control-label order-form-title">{{genderText | translate}}: </label>
                <label class="control-label order-form-value" id="gender">{{patientVal.gender}} </label>
              </div>
              <div class="order-form-item Flexbox">
                <label class="control-label order-form-title">{{'DOB:' | translate}} </label>
                <label class="control-label order-form-value" id="birthDate">{{patientVal.birthDate}} </label>
              </div>
              <div class="order-form-item Flexbox" *ngIf="hasEthnicity">
                <label class="control-label order-form-title">{{'Ethnicity:' | translate}} </label>
                <label class="control-label order-form-value"
                  id="ethnicity">{{patientVal.demographics.ethnicity.display}}</label>
              </div>
            </div>
          </div>

          <div class="Flexbox__flex-1">
            <div class="order-form-item Flexbox required">
              <label class="control-label order-form-title">
                {{'Test Number:' | translate}}
              </label>
              <div class="order-form-value">
                <input #testNumber="ngModel"
                       name="testNumber"
                       type="text" class="form-control"
                       placeholder="{{testNumberPlaceholder | translate}}"
                       required="{{!identifierFormula}}"
                       [pattern]="testNumberRegExp"
                       [disabled]="identifierFormula"
                       [(ngModel)]="testNumberValue"
                       (ngModelChange)="OnTestNumberChange($event)"
                       [ngModelOptions]="{standalone: true}" />
                <gen-invalid-tooltip class="invalid-tooltip-wrapper tooltip-long-text"
                                     [tooltipRequired]="shouldShowTooltipForTestNumber(testNumber.invalid)"
                                     [tooltipText]="'Test number is required and should contain only A-Z a-z 0-9 . - _ It should start and end with a letter or number, and cannot contain dashes next to periods.'"
                ></gen-invalid-tooltip>

              </div>
            </div>

            <div class="order-form-item Flexbox required">
              <label class="control-label order-form-title">
                {{'Test:' | translate}}
              </label>
              <div class="wrapper" genTooltip tooltipPosition="BOTTOM" [appendToBody]="true" [tooltipText]="information"
                tooltipShow="true">
                <div class="order-form-value">
                  <select [(ngModel)]="tempWorkflowRequest.name" class="form-control" required name="workflowRequest"
                    (change)="setWorkflowRequest(tempWorkflowRequest)" [disabled]="disableSelectTest">
                    <option *ngFor="let org of this.analyses" [ngValue]="org.name" [selected]="selectedOrganization == org.name">
                      {{org.name}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- draft mode will be defined in on of dynamic forms as a field -->
        <div class="dynamic-form-container"
          [ngClass]="{'form-row-container':!formColumnLayout,'form-column-container':formColumnLayout}">



          <section *ngIf="formsConfig && formsConfig.length > 0 && diagnosticOrder.workflowRequest">
            <div *ngFor="let formConfig of formsConfig;let i=index" class="form-override order-form-content Flexbox"
                 [ngClass]="formConfig.formHalfWidth ? 'half-width' :'full-width'">
              <gen-dynamic-form #dynamicFormReference
                                [formName]="formConfig.formId"
                                [title]="formConfig.title"
                                [subTitle]="formConfig.subTitle"
                                [disabled]="false"
                                [resetForm]="validate"
                                [updateField]="updateFieldObject"
                                [titleClass]="formConfig.titleClass"
                                [disabledFields]="formConfig.disabledFields"
                                [submitted]="isSubmitted"
                                [formVertical]="formConfig.formVertical"
                                [formHalfWidth]="formConfig.formHalfWidth"
                                [formItemFullWidth]="formConfig.formItemFullWidth || false"
                                [formData]="formConfig.default"
                                (formInit)="updateForm($event, null)"
                                (formChange)="updateForm($event.form,formConfig.key)"
                                (validateChange)="validationUpdate($event,i+1)">
              </gen-dynamic-form>
            </div>
          </section>

        </div>

        <div class="order-form-content Flexbox " *ngIf="diagnosticOrder.workflowRequest && shouldShowNotes">
          <div class="Flexbox order-form-item flex50">
            <div class="order-form-title flex18">
              <label>Notes</label>
            </div>
            <div class="height7rem">
              <textarea [(ngModel)]="diagnosticOrder.notes" [ngModelOptions]="{standalone: true}" type="text"
                class="form-control not-resize textarea-control txtAreaCls" placeholder="Enter Note"
                rows="3"></textarea>
            </div>
          </div>
        </div>

        <div class="order-form-content Flexbox ">
          <section class="specimenSampleSection Flexbox__flex-1"
            *ngIf="diagnosticOrder.workflowRequest && specimenConfig && specimenConfig.length > 0  && !hideSpecimenInOrderFrom">

            <div [ngClass]="specimenConfig.length>1 && !flexWidth ? 'flexBasis50' : 'flexBasis100'"
              *ngFor="let spec of specimenConfig; let i=index">
              <ng-container *ngIf="spec.formsToLoad; else dynamicSpecimen">
                <ng-container *ngFor="let formId of spec.formsToLoad">
                  <gen-specimen-type #specimenTypeReference
                                     [specimenType]="spec.specimenType"
                                     [sampleType]="spec.sampleType"
                                     [specimenTemplate]="getSpecimenTemplate(spec)"
                                     [collections]="testInfoCollections"
                                     [index]="i"
                                     [diagnosticOrder]="diagnosticOrder"
                                     [showBatchId]="showBatchId"
                                     [isSubmitted]="isSubmitted"
                                     [formId]="formId.name"
                                     [formTitle]="formId.title"
                                     [editMode]="false">
                  </gen-specimen-type>
                </ng-container>
              </ng-container>

              <ng-template #dynamicSpecimen>
                <gen-specimen-type #specimenTypeReference
                                   [specimenType]="spec.specimenType"
                                   [sampleType]="spec.sampleType"
                                   [specimenTemplate]="getSpecimenTemplate(spec)"
                                   [collections]="testInfoCollections"
                                   [index]="i"
                                   [diagnosticOrder]="diagnosticOrder"
                                   [showBatchId]="showBatchId"
                                   [isSubmitted]="isSubmitted"
                                   [formId]="spec.formId"
                                   [formTitle]="spec.title"
                                   [editMode]="false">
                </gen-specimen-type>
              </ng-template>
            </div>
          </section>
        </div>
        <span class="order-form-content blurb-text Flexbox" *ngIf="blurb">{{blurb}}</span>
        <div class="order-form-item Flexbox">
          <span class="order-form-title"></span>
          <div class="order-form-value Flexbox__just-end Flexbox">
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- footer section -->
  <div class="Flexbox bottom-menu">
    <div>
      <input id="cancel-button" type="button" [disabled]="isRequestInProgress" class="btn btn-normal quiet__button"
        value="{{'Cancel' | translate}}" (click)="cancel()" />
    </div>
    <div>
      <input [disabled]="disableSubmitButton()" type="submit" class="btn submitButton Auto_Button_Submit"
        value="{{'Submit' | translate}}" id="new-order-submit-button">
    </div>
  </div>
</form>
</div>
